export { default } from './AppConfirmRegistrationView';
